import React, { useState } from "react";
import { useHistory } from "react-router";
import { config } from "../../../../config/domain";
import { useQuery } from "../../../service/urlHelper";

export const PaymentResponse = (props: any) => {
  const urlSearchParams = new URLSearchParams(useHistory().location.search);
  const params = Object.fromEntries(urlSearchParams.entries());
  localStorage.setItem("paymentReponse", params.status);
  function redirect(url: string) {
    if (url.indexOf("http://") === 0 || url.indexOf("https://") === 0) {
      // If url is absolute
      window.location.href = url;
    }
  }
  redirect(config.root + "app/clientarea/service-request/account-reactivation");
  return <></>;
};
